/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CopilotThreadsService
 */

export const AskAcademyRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.AskAcademyRequest';
export const AskInAppHelpRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.AskInAppHelpRequest';
export const CompanyCompetitorsRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CompanyCompetitorsRequest';
export const CompanyFundingRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CompanyFundingRequest';
export const CompanyLookupRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CompanyLookupRequest';
export const CompanyTechRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CompanyTechRequest';
export const ContentRewriteRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ContentRewriteRequest';
export const CopilotCapabilitiesRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CopilotCapabilitiesRequest';
export const CreateBlogPostRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CreateBlogPostRequest';
export const CreateNewsSubscriptionRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CreateNewsSubscriptionRequest';
export const CustomSystemPromptRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.CustomSystemPromptRequest';
export const DeleteNewsSubscriptionRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.DeleteNewsSubscriptionRequest';
export const DiscoverCompaniesRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.DiscoverCompaniesRequest';
export const DraftBlogPostRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.DraftBlogPostRequest';
export const DraftSalesEmailRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.DraftSalesEmailRequest';
export const DraftSalesEmailTemplateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.DraftSalesEmailTemplateRequest';
export const ImageGenerateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ImageGenerateRequest';
export const ListNewsSubscriptionsRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ListNewsSubscriptionsRequest';
export const ListNotesRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ListNotesRequest';
export const NewsRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.NewsRequest';
export const NoteCreateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.NoteCreateRequest';
export const NoteCreateTemplateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.NoteCreateTemplateRequest';
export const ObjectAddRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectAddRequest';
export const ObjectAssignRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectAssignRequest';
export const ObjectAssociationsRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectAssociationsRequest';
export const ObjectCountRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectCountRequest';
export const ObjectListRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectListRequest';
export const ObjectSummaryRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectSummaryRequest';
export const ObjectUpdateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ObjectUpdateRequest';
export const OrchestrationPlanExecutionRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.OrchestrationPlanExecutionRequest';
export const OrchestrationPlanningRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.OrchestrationPlanningRequest';
export const ReportBuilderRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.ReportBuilderRequest';
export const SummarizeArticleRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.SummarizeArticleRequest';
export const TaskCreateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.TaskCreateRequest';
export const TaskCreateTemplateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.TaskCreateTemplateRequest';
export const TextGenerateRequestTypename = 'com.hubspot.chatspot.intent.schemas.chatspot.TextGenerateRequest';
export const ActionButtonTypename = 'com.hubspot.chatspot.message.schemas.buttons.ActionButton';
export const ActionButtonV2Typename = 'com.hubspot.chatspot.message.schemas.buttons.ActionButtonV2';
export const LinkButtonTypename = 'com.hubspot.chatspot.message.schemas.buttons.LinkButton';
export const TemplateButtonTypename = 'com.hubspot.chatspot.message.schemas.buttons.TemplateButton';
export const AccordionResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.AccordionResponseSection';
export const ActionsResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ActionsResponseSection';
export const BarChartResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.BarChartResponseSection';
export const CardWrapperResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.CardWrapperResponseSection';
export const CollaborationResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.CollaborationResponseSection';
export const ConfirmationResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ConfirmationResponseSection';
export const CrmCardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.CrmCardResponseSection';
export const DashboardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.DashboardResponseSection';
export const DataTableResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.DataTableResponseSection';
export const DenseListResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.DenseListResponseSection';
export const ErrorResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ErrorResponseSection';
export const FilterBranchResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.FilterBranchResponseSection';
export const GridResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.GridResponseSection';
export const HtmlTextResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.HtmlTextResponseSection';
export const LlmResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.LlmResponseSection';
export const PlainTextResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.PlainTextResponseSection';
export const ReportResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ReportResponseSection';
export const SourcesListResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.SourcesListResponseSection';
export const TemplateResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.TemplateResponseSection';
export const ThoughtResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.ThoughtResponseSection';
export const UnstyledImageResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.UnstyledImageResponseSection';
export const UserActionResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.UserActionResponseSection';
export const UserChatResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.UserChatResponseSection';
export const VisualizationResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.VisualizationResponseSection';
export const CardResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.card.CardResponseSection';
export const CompanyCardTypename = 'com.hubspot.chatspot.message.schemas.sections.card.CompanyCard';
export const DoubleCardFieldValueTypename = 'com.hubspot.chatspot.message.schemas.sections.card.DoubleCardFieldValue';
export const IntegerCardFieldValueTypename = 'com.hubspot.chatspot.message.schemas.sections.card.IntegerCardFieldValue';
export const LinkCardFieldValueTypename = 'com.hubspot.chatspot.message.schemas.sections.card.LinkCardFieldValue';
export const StringCardFieldValueTypename = 'com.hubspot.chatspot.message.schemas.sections.card.StringCardFieldValue';
export const FileAttachmentResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.file.FileAttachmentResponseSection';
export const ImageGridResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.image.ImageGridResponseSection';
export const MediaPreviewResponseSectionTypename = 'com.hubspot.chatspot.message.schemas.sections.media.MediaPreviewResponseSection';
export const MediaPreviewResponseSectionV2Typename = 'com.hubspot.chatspot.message.schemas.sections.media.MediaPreviewResponseSectionV2';
export const BrandVoiceFieldTypename = 'com.hubspot.chatspot.message.schemas.sections.metadata.BrandVoiceField';
export const AISkillSourceDataTypename = 'com.hubspot.chatspot.message.schemas.sections.sources.AISkillSourceData';
export const AppSourceDataTypename = 'com.hubspot.chatspot.message.schemas.sections.sources.AppSourceData';
export const KnowledgeBoxSourceDataTypename = 'com.hubspot.chatspot.message.schemas.sections.sources.KnowledgeBoxSourceData';
export const WebsiteSourceDataTypename = 'com.hubspot.chatspot.message.schemas.sections.sources.WebsiteSourceData';
export const CrossTabVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.crosstab.CrossTabVisualization';
export const DatawellVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.datawell.DatawellVisualization';
export const FunnelVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.funnel.FunnelVisualization';
export const GaugeVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.gauge.GaugeVisualization';
export const PivotVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.pivot.PivotVisualization';
export const SankeyVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.sankey.SankeyVisualization';
export const SlicedVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.sliced.SlicedVisualization';
export const TableVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.table.TableVisualization';
export const WaterfallVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.waterfall.WaterfallVisualization';
export const XYVisualizationTypename = 'com.hubspot.chatspot.message.schemas.sections.visualization.xy.XYVisualization';
export const ActionCellTypename = 'com.hubspot.chatspot.message.schemas.table.ActionCell';
export const ImageCellTypename = 'com.hubspot.chatspot.message.schemas.table.ImageCell';
export const LinkCellTypename = 'com.hubspot.chatspot.message.schemas.table.LinkCell';
export const PlainTextCellTypename = 'com.hubspot.chatspot.message.schemas.table.PlainTextCell';
export const LinkTokenTypename = 'com.hubspot.chatspot.message.schemas.tokens.LinkToken';
export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';

/**
 *  Represents feedback provided for a copilot message.
 */

/**
 *  Represents a Thread with an ID (after insertion)
 */

export let ComHubspotCopilotModelsChat;
(function (_ComHubspotCopilotModelsChat) {})(ComHubspotCopilotModelsChat || (ComHubspotCopilotModelsChat = {}));
export const EmptyPayloadTypename = 'com.hubspot.copilot.models.chat.payload.EmptyPayload';
export const JsonPayloadTypename = 'com.hubspot.copilot.models.chat.payload.JsonPayload';
/**
 *  JSON payload for the raw output response.
 */

export const ToolCallPayloadTypename = 'com.hubspot.copilot.models.chat.payload.ToolCallPayload';
export const CopilotResponseTypename = 'com.hubspot.copilot.models.messages.CopilotResponse';
export const UserResponseTypename = 'com.hubspot.copilot.models.messages.UserResponse';
export let ComHubspotCopilotModelsMessages;
(function (_ComHubspotCopilotModelsMessages) {})(ComHubspotCopilotModelsMessages || (ComHubspotCopilotModelsMessages = {}));
export let ComHubspotCopilotModelsPreviews;
(function (_ComHubspotCopilotModelsPreviews) {})(ComHubspotCopilotModelsPreviews || (ComHubspotCopilotModelsPreviews = {}));
/**
 *  Request to get a thread with all its messages.
 */
/**
 *  Response for getting a thread with all its messages.
 */
/**
 *  Request to list threads for a portal user.
 *  Does not require any additional parameters as it uses context.
 */
/**
 *  Response for listing threads for a portal user.
 *  Contains a list of threads for the user.
 */
export const CrmCitationTypename = 'com.hubspot.copilot.tools.results.citations.CrmCitation';
export const DashworksCitationTypename = 'com.hubspot.copilot.tools.results.citations.DashworksCitation';
export const LegacyCitationTypename = 'com.hubspot.copilot.tools.results.citations.LegacyCitation';
export const WebPageCitationTypename = 'com.hubspot.copilot.tools.results.citations.WebPageCitation';
export const getThreadWithInteractionsRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotThreadsService',
  rpcName: 'getThreadWithInteractions',
  auth: 'app',
  fingerprint: 'sjD2LKXn0wVJ94Tqv-8kAKVNEWbjYErK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getThreadMetadataRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotThreadsService',
  rpcName: 'getThreadMetadata',
  auth: 'app',
  fingerprint: '-QmMXt7nq2tNPEe7okVBBaVNEWbjYErK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getLatestThreadAndInteractionOrCreateNewRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotThreadsService',
  rpcName: 'getLatestThreadAndInteractionOrCreateNew',
  auth: 'app',
  fingerprint: 'HDuJzJSoic1J94Tqv-8kAKVNEWbjYErK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBoxIdFromThreadRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotThreadsService',
  rpcName: 'getBoxIdFromThread',
  auth: 'app',
  fingerprint: '0enVFT3tZj5z70pUq0iqC6VNEWbjYErK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getThreadsRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotThreadsService',
  rpcName: 'getThreads',
  auth: 'app',
  fingerprint: '5o4zEUngSqLts4VAdDkw56VNEWbjYErK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createNewThreadRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotThreadsService',
  rpcName: 'createNewThread',
  auth: 'app',
  fingerprint: 'mN4-ZFIuZOZJ94Tqv-8kAKVNEWbjYErK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const renameThreadLabelRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotThreadsService',
  rpcName: 'renameThreadLabel',
  auth: 'app',
  fingerprint: 'fhh1poHAQEhNPEe7okVBBaVNEWbjYErK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const softDeleteThreadRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotThreadsService',
  rpcName: 'softDeleteThread',
  auth: 'app',
  fingerprint: '-QmMXt7nq2uNn5IOyAAoPqVNEWbjYErK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const mergeThreadWithLatestThreadRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotThreadsService',
  rpcName: 'mergeThreadWithLatestThread',
  auth: 'app',
  fingerprint: '-QmMXt7nq2tJ94Tqv-8kAKVNEWbjYErK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getThreadWithLatestPreviewOrCreateNewRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotThreadsService',
  rpcName: 'getThreadWithLatestPreviewOrCreateNew',
  auth: 'app',
  fingerprint: 'TB6IZJWTvTNJ94Tqv-8kAKVNEWbjYErK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listForPortalUserRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotThreadsService',
  rpcName: 'listForPortalUser',
  auth: 'app',
  fingerprint: 'sd0py8MLghwUuDB1LIAwcqVNEWbjYErK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getThreadWithMessagesRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotThreadsService',
  rpcName: 'getThreadWithMessages',
  auth: 'app',
  fingerprint: '5eDfoxWf4hB2j_uS2qY4_6VNEWbjYErK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};